import { render, staticRenderFns } from "./DemoReviewersTable.vue?vue&type=template&id=132cf00c&scoped=true"
import script from "./DemoReviewersTable.vue?vue&type=script&lang=js"
export * from "./DemoReviewersTable.vue?vue&type=script&lang=js"
import style0 from "./DemoReviewersTable.vue?vue&type=style&index=0&id=132cf00c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132cf00c",
  null
  
)

export default component.exports